import { FC, useEffect } from 'react';
import { useSetAtom } from 'jotai';
import { nameSearchQueryAtomJ } from '../../../services/state/PeopleByCompanyStateJ';
import { SearchInput } from '../../../CoreComponents/base/SearchInput';

export const SearchByName: FC = () => {
  const setNameQuery = useSetAtom(nameSearchQueryAtomJ);

  useEffect(() => {
    return () => {
      setNameQuery('');
    };
  }, [setNameQuery]);

  return <SearchInput style={{ width: '14rem' }} onChange={setNameQuery} placeholder='Search by name' />;
};
